import { Route } from '@angular/router';

/**
 * Whether the user may enter a route. The AuthGuard and the navigation menu share this
 * rule, so a visible menu item is always an enterable page and vice versa:
 *
 * - `data.permission`: that single permission is required.
 * - `data.anyPermission`: at least one of the listed permissions is required. For pages
 *   that bundle several features and have no single natural permission.
 * - Neither declared, but the route has children: the route is a hub (e.g. settings)
 *   and opens as soon as any of its children does - no own permission to maintain.
 * - Neither declared, no children: open to any authenticated user.
 */
export function hasRouteAccess(route: Route, permissions: string[]): boolean {
  const data = route.data ?? {};

  if (data['permission']) {
    return permissions.includes(data['permission']);
  }

  const anyPermission = data['anyPermission'] as string[] | undefined;

  if (anyPermission?.length) {
    return anyPermission.some(permission => permissions.includes(permission));
  }

  if (route.children?.length) {
    return route.children.some(child => hasRouteAccess(child, permissions));
  }

  return true;
}
